import createItemFetcher from "../helpers/item";
import { createActionDuck } from "../helpers/action";
import { combineDucks } from "../helpers/combineDucks";
import { createNotificationOnCreateEpic, createNotificationOnCreateErrorEpic, } from "./updateNotification";
import { listenToDataPanelMMIChangesEpic } from "../uischemas/mmiSubscription";
const computeAccessLevelsUrl = (config) => {
    const { scenario, program, panelName, workspace } = config;
    const program_lc = program.toLowerCase();
    let fixedPanelName = panelName.slice();
    if (panelName.indexOf("_") !== -1) {
        fixedPanelName = panelName.substring(0, panelName.indexOf("_"));
    }
    const url = `/api/v1/uischema/levels/${scenario}/${workspace}/${program_lc}/${fixedPanelName}`;
    return url;
};
function computeItemId(config) {
    const { program, panelName } = config;
    return `${program}_${panelName}`;
}
const accessLevelGetDuck = createItemFetcher(computeAccessLevelsUrl, "GET_ACCESS_LEVELS", computeItemId);
const computeAccessLevelPost = (config) => {
    const { scenario, program, panelName, workspace } = config;
    const program_lc = program.toLowerCase();
    let fixedPanelName = panelName.slice();
    if (panelName.indexOf("_") !== -1) {
        fixedPanelName = panelName.substring(0, panelName.indexOf("_"));
    }
    const url = `/api/v1/uischema/levels/${scenario}/${workspace}/${program_lc}/${fixedPanelName}`;
    return {
        method: "POST",
        url,
    };
};
const accessLevelPostDuck = createActionDuck("POST_ACCESS_LEVELS", computeAccessLevelPost, computeItemId);
accessLevelPostDuck.middleware.push(createNotificationOnCreateEpic(accessLevelPostDuck.ActionKeys), createNotificationOnCreateErrorEpic(accessLevelPostDuck.ActionKeys), listenToDataPanelMMIChangesEpic(accessLevelGetDuck.actions.fetchItem));
export const accessLevels = combineDucks({
    getAccessLevels: accessLevelGetDuck,
    postAccessLevels: accessLevelPostDuck,
});
//# sourceMappingURL=index.js.map